var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cal-card"},[(_vm.loading)?_c('v-progress-linear',{staticClass:"cal-progress",attrs:{"indeterminate":"","color":"accent","height":"2"}}):_vm._e(),_c('month-calendar',{attrs:{"events":_vm.daysWithRoutines,"readonly":"","flat":"","dense":"","month":_vm.pickerDate},on:{"update:month":function($event){_vm.pickerDate=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }